export var PaymentMethodValues = [
    'bank_transfer',
    'card_visa',
    'card_master',
    'card_jcb',
    'card_amex',
    'card_diners',
];
export var PaymentTimingValues = [
    'one_time_upfront',
    'one_time_specified_date',
    'one_time_after_imported',
    'lump_sum_payment_after_import',
    'two_times_after_imported',
    'three_times_after_imported',
    'four_times_after_imported',
    'five_times_after_imported',
    'one_time_after_first_delivery',
    'after_each_delivery',
];
export var DeliveryMethodValues = ['bulk', 'split'];
export var StatusValues = [
    'under_review',
    'reserved',
    'confirmed',
    'canceled',
];
export var TypicaStockOneTimeUpfrontRate = '5';
export var TypicaStockOneTimeAfterFirstDeliveryRate = '0';
export var TypicaStockAfterEachDeliveryRate = '5';
export var TypicaStockOneTimeAfterImportedRate = '0';
export var TypicaStockHandlingRates = {
    less_than_300kg: '35.0',
    more_than_300kg: '25.0',
    more_than_600kg: '20.0',
    more_than_3000kg: '15.0',
};
